<script lang="ts">
  import type { Snippet } from 'svelte';
  import { CircleAlert, CircleCheck, Info, TriangleAlert } from 'lucide-svelte';

  interface Props {
    tone?: 'info' | 'warning' | 'error' | 'success';
    title?: string;
    live?: 'polite' | 'assertive';
    children?: Snippet;
    actions?: Snippet;
  }

  let { tone = 'info', title, live, children, actions }: Props = $props();

  const ICONS = { info: Info, warning: TriangleAlert, error: CircleAlert, success: CircleCheck } as const;
  const Icon = $derived(ICONS[tone]);
</script>

<div
  class="stat-alert stat-alert--{tone}"
  role={live === 'assertive' ? 'alert' : live === 'polite' ? 'status' : undefined}
>
  <Icon size={20} aria-hidden="true" />
  <div class="stat-alert__content">
    {#if title}<p class="stat-alert__title">{title}</p>{/if}
    {#if children}<div class="stat-alert__body">{@render children()}</div>{/if}
    {#if actions}<div class="stat-alert__actions">{@render actions()}</div>{/if}
  </div>
</div>
